import {
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    FormControlLabel,
    FormHelperText,
    Grid,
    Link,
    Modal,
    Typography,
} from '@mui/material';
import { OrbitSectionHeader } from '../components/orbitSectionHeader';
import { useOrbitPrivacyConsent } from './hook';
import { OrbitPrivacyConsentProps } from '../sectionProps';
import FieldText from '../../../components/general/fields/fieldText';

export const OrbitPrivacyConsent = (props: OrbitPrivacyConsentProps) => {
    const { readOnly } = props;
    const { formik, open, handleOpen, handleClose } =
        useOrbitPrivacyConsent(props);

    const showAcceptTermsError =
        formik.touched.acceptTerms && Boolean(formik.errors.acceptTerms);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <OrbitSectionHeader title="Privacidad y Consentimientos" />
            </Grid>

            <Grid item xs={12}>
                {readOnly ? (
                    <FieldText
                        label="Acepto tratamiento de datos personales"
                        name="acceptTerms"
                        size="small"
                        disabled
                        value={formik.values.acceptTerms ? 'Sí' : 'No'}
                    />
                ) : (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formik.values.acceptTerms}
                                onChange={(e) => {
                                    formik.setFieldValue(
                                        'acceptTerms',
                                        e.target.checked
                                    );
                                    formik.setFieldTouched('acceptTerms', true);
                                }}
                                onBlur={formik.handleBlur}
                                name="acceptTerms"
                                required
                            />
                        }
                        label={
                            <label
                                onClick={handleOpen}
                                className="link-button"
                                style={{ fontWeight: 'bold' }}
                            >
                                Acepto tratamiento de datos personales
                            </label>
                        }
                    />
                )}
                {!readOnly && showAcceptTermsError && (
                    <FormHelperText error sx={{ ml: 1.75 }}>
                        {formik.errors.acceptTerms}
                    </FormHelperText>
                )}
            </Grid>

            <Grid item xs={12}>
                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    Al hacer clic el botón enviar, usted acepta la remisión de
                    la PQR a la Previsora S.A Compañía de Seguros. Sus datos
                    serán recolectados y tratados conforme con la Política de
                    Tratamiento de Datos. En la opción consulta de PQRSD podrá
                    verificar el estado de la respuesta.
                    <br />
                    <br />
                    En caso que la solicitud de información sea de naturaleza de
                    identidad reservada, deberá efectuar el respectivo trámite
                    ante la Procuraduría General de la Nación, haciendo clic en
                    el siguiente link:{' '}
                    <Link
                        href="https://sedeelectronica.procuraduria.gov.co/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        solicitud_informacion_identificacion_reservada
                    </Link>
                    <br />
                    <br />
                    En caso de requerir radicar una denuncia anónima por favor
                    dirigirse al siguiente link:{' '}
                    <Link
                        href="https://www.previsora.gov.co/web/guest/linea-etica"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        linea etica
                    </Link>
                </Typography>
            </Grid>

            <Modal
                open={!readOnly && open}
                onClose={handleClose}
                aria-labelledby="orbit-privacy-modal-title"
                aria-describedby="orbit-privacy-modal-description"
            >
                <Box
                    className="modal-card-container"
                    sx={{
                        width: '70%',
                        maxHeight: '50%',
                        top: '30%',
                    }}
                >
                    <Card className="modal-card">
                        <CardContent>
                            <Typography
                                id="orbit-privacy-modal-title"
                                variant="h6"
                                component="h2"
                                className="modal-card-title"
                            >
                                Autorización Datos Personales
                            </Typography>
                            <Typography
                                id="orbit-privacy-modal-description"
                                variant="body2"
                                component="p"
                                className="modal-card-content"
                                sx={{
                                    maxHeight: '60vh',
                                    overflowY: 'auto',
                                    padding: '0.5rem',
                                }}
                            >
                                Autorizo expresamente a La Previsora S.A,
                                Compañía de Seguros con NIT. 860002400-2 como
                                responsable del tratamiento de la información,
                                para utilizar nombre, teléfono de contacto,
                                correo electrónico y demás datos personales
                                compartidos con la compañía por medio de este
                                formulario con el fin de :
                                <br />
                                <br />
                                a) Realizar gestiones de conocimiento al cliente
                                y verificación o actualización de información a
                                través de correo electrónico, mensajes de texto
                                MMS/SMS y/o telefónicamente; b) Tramitar mis
                                solicitudes o recibir información general sobre
                                automóviles, SOAT, hogar, áreas comunes y otros
                                ramos c) Enviar correspondencia, correos
                                electrónico, mensajes de texto (SMS) o hacer
                                contacto telefónico en desarrollo de actividades
                                publicitarias, de mercadeo, ofrecimiento de
                                productos o servicios nuevos y actuales
                                considerados de su interés; d) Compartir esta
                                información con terceros conforme se haga
                                necesario para realizar actividades comprendidas
                                dentro de su objeto social y/o para el ejercicio
                                de actividades relacionadas con estas mismas
                                finalidades; e) Realizar encuestas de
                                satisfacción y percepción sobre los productos y
                                servicios de la compañía por cualquier medio; f)
                                Para la prestación de todos los servicios
                                convenidos dentro del contrato de seguros en
                                caso que tenga la calidad de asegurado o
                                beneficiario; g) atender requerimientos de
                                autoridades en ejercicio de sus funciones; h)
                                conservarla para fines históricos y/o
                                estadísticos. Especialmente declaro que he
                                recibido información sobre el carácter
                                facultativo de la respuesta a las preguntas que
                                me sean efectuadas, cuando estas versen sobre
                                datos sensibles o sobre datos de niñas, niños y
                                adolescentes, y que de acuerdo con la
                                legislación colombiana vigente en materia de
                                protección de datos personales, como titular de
                                la información tengo derecho a conocer,
                                actualizar, rectificar y suprimir mis datos
                                personales, esto último, en caso de ser posible,
                                al no mediar una relación contractual o legal
                                que impida el retiro de la información, enviando
                                solicitud al correo electrónico
                                contactenos@previsora.gov.co, enviando
                                comunicación escrita a la Calle 57 # 9 – 07 en
                                Bogotá, en el teléfono 3487555 o a través del
                                sistema PQR disponible en la página WEB
                                www.previsora.gov.co.
                                <br />
                                <br />
                                Que como titular de los datos me asisten los
                                derechos establecidos en la ley 1581 de 2012 y
                                sus Decretos reglamentarios o demás normas que
                                la modifiquen, adicionen o complementen, en
                                especial los derechos a: a) Conocer, actualizar
                                y rectificar mis datos b) Solicitar prueba de la
                                autorización otorgada; c) Ser informado del uso
                                que le ha dado a sus datos personales; d)
                                Presentar ante la Superintendencia de Industria
                                y Comercio quejas por infracciones a las
                                disposiciones legales vigentes e) Revocar la
                                autorización y/o solicitar la supresión del dato
                                cuando en el Tratamiento no se respeten los
                                principios, derechos y garantías
                                constitucionales y legales. f) Acceder en forma
                                gratuita a mis datos personales que hayan sido
                                objeto de Tratamiento al menos una vez cada mes
                                calendario y cada vez que existan modificaciones
                                sustanciales de las Políticas de Tratamiento de
                                la información que motiven nuevas consultas.
                                Dejo constancia que se me ha suministrado
                                información comprensible en torno a mis derechos
                                referentes con el tratamiento de mi información
                                personal, en particular el de presentar
                                consultas, peticiones y quejas. Para más
                                información sobre la Política de privacidad de
                                la compañía, así como los derechos de los
                                titulares de la información y la manera de
                                ejercerlos es posible acceder a la página de
                                internet www.previsora.gov.co
                            </Typography>
                            <Box sx={{ textAlign: 'right', mt: 3 }}>
                                <Button
                                    variant="contained"
                                    className="modal-card-button"
                                    onClick={handleClose}
                                >
                                    Acepto
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
        </Grid>
    );
};
